var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    ref: "RevokeDialog",
    staticClass: "revoke-confirmation",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__("common.actions.revoke_access")
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: _vm.closeModal
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Vous êtes sur le point d’annuler l’accès à votre compte aux collaborateurs Sellsy. Cette action est définitive, êtes-vous certain de vouloir annuler cet accès ?"
                    )
                  ) +
                  "\n        "
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: { click: _vm.closeModal }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  ref: "revokeButton",
                  attrs: {
                    label: _vm.$t.__("common.actions.revoke_access"),
                    type: "primary-destructive"
                  },
                  on: { click: _vm.handleRevoke }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }